/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faCassetteTape} from '@fortawesome/pro-duotone-svg-icons';

const PdPlaylistIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faCassetteTape} {...props} />
);

export default PdPlaylistIcon;
